import { render, staticRenderFns } from "./lazyblock_core_free.vue?vue&type=template&id=35d468e3&scoped=true"
import script from "./lazyblock_core_free.vue?vue&type=script&lang=js"
export * from "./lazyblock_core_free.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d468e3",
  null
  
)

export default component.exports